module.exports = __webpack_public_path__ + "img/c73.8be00618.png";